import CloseTask from './CloseTask';

export default CloseTask;
